import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-category-plp-loading',
  templateUrl: './category-plp-loading.component.html',
  styleUrls: ['./category-plp-loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CategoryPlpLoadingComponent {
  @Input() isLandScapeTablet: boolean;
  @Input() isDesktop: boolean;
  @Input() isTablet: boolean;
  @Input() isMobile: boolean;
}
